import { Angular5Csv } from 'angular5-csv/Angular5-csv';
import { Component, Input } from '@angular/core';

import { ACCOUNT_OPTIONS, MOCK_DATA } from '../../constants/export.constant';

@Component({
  selector: 'export-account',
  template: `<a class="btn mr2" title="Download Report">Ex</a>`
})
export class ExportAccountComponent {
  @Input() public data = MOCK_DATA;
  public options = ACCOUNT_OPTIONS;

  public export(): void {
    new Angular5Csv(this.data, 'My Report', this.options);
  }
}
